/*
 * @Author: Veto [通用的一些方法]
 * @Date: 2021-06-17 11:34:22 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-03-15 10:12:39
 */



module.exports = {
    is_weixin() {
        const ua = navigator.userAgent.toLowerCase();
        return ua.match(/MicroMessenger/i) == 'micromessenger'
    },

    is_qq() {
        const ua = navigator.userAgent.toLowerCase();
        const isBrowser = ua.indexOf('MQQBrowser') > -1 || ua.indexOf('tencenttraveler') > -1 || ua.indexOf('qqbrowse') > -1;
        return ua.match(/QQ/i) == 'qq' && !isBrowser;
    },

    isAndroid() {
        const u = navigator.userAgent;
        return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    },

    isIos() {
        const u = navigator.userAgent;
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
}